/**
 * Petit badge texte pour identifier une entité dans une vue consolidée.
 * Utilisé sur À payer, BalanceCard en mode groupe, etc.
 *
 * Usage : <EntityBadge slug="legendary" name="Legendary Parts" />
 */

const SLUG_SHORT = {
  legendary: 'LP',
  juvo:      'JUVO',
  suzuki:    'SZK',
};

function shorten(slug, name) {
  if (slug && SLUG_SHORT[slug]) return SLUG_SHORT[slug];
  if (slug) return slug.slice(0, 4).toUpperCase();
  if (name) return name.slice(0, 4).toUpperCase();
  return '?';
}

export default function EntityBadge({ slug, name, className = '' }) {
  const label = shorten(slug, name);
  return (
    <span
      className={`inline-flex items-center rounded-md bg-slate-100 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-slate-600 ring-1 ring-inset ring-slate-200 ${className}`}
      title={name}
    >
      {label}
    </span>
  );
}
